import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import HomePage from './HomePage';
import Pricing from './Pricing';
import About from './About';
import Services from './Services';
// import Consulting from './Consulting';
import Documentation from './Documentation';
import Security from './Security';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import RequestDemo from './RequestDemo';
import ShopifyData from './ShopifyData';
import FacebookTargeting from './FacebookTargeting';
import SignIn from './SignIn';
import SignUp from './SignUp';
import SignUpLimit from './SignUpLimit';
import SignUpLimitThanks from './SignUpLimitThanks';
import ScheduleServices from './ScheduleServices';
import RequestConsult from './RequestConsult';
import StreamLocatorCaseStudy from './StreamLocatorCaseStudy';
import SMSLiveCaseStudy from './SMSLiveCaseStudy';
import FreeTrial from './FreeTrial';
import FreeVersion from './FreeVersion';
import FloSQLSnowflake from './FloSQLSnowflake';
import FloSQLRedshift from './FloSQLRedshift';
import FloSQLBigQuery from './FloSQLBigQuery';
import FormSubmitted from './FormSubmitted';
import FormSubmittedFree from './FormSubmittedFree';
import SelectDestination from './SelectDestination';
import useGaTracker from './../../useGaTracker';
// import { useIntercom } from 'react-use-intercom';
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';

export default function App() {
  useGaTracker();

  const tawkMessengerRef = useRef();

  // const { boot, shutdown, hide, show, update } = useIntercom();

  // useEffect(boot,[]);

return (
  <div>
    <TawkMessengerReact
                propertyId="63052f1037898912e964bb93"
                widgetId="1gb63vlsv"
                ref={tawkMessengerRef}/>
    <Switch>
      {/* add routes with layouts */}
      <Route path="/Pricing" exact component={Pricing} />
      <Route path="/About" exact component={About} />
      <Route path="/Services" exact component={Services} />
      <Route path="/Services/index.html" exact component={Services} />
      <Route path="/ScheduleServices" exact component={ScheduleServices} />
      {/*<Route path="/Consulting" exact component={Consulting} />*/}
      <Route path="/Documentation" exact component={Documentation} />
      <Route path="/Security" exact component={Security} />
      <Route path="/PrivacyPolicy" exact component={PrivacyPolicy} />
      <Route path="/TermsOfService" exact component={TermsOfService} />
      <Route path="/RequestDemo" exact component={RequestDemo} />
      <Route path="/ShopifyData" exact component={ShopifyData} />
      <Route path="/FacebookTargeting" exact component={FacebookTargeting} />
      <Route path="/SignIn" exact component={SignIn} />
      <Route path="/SignUp" exact component={SignUp} />
      <Route path="/SignUpLimit" exact component={SignUpLimit} />
      <Route path="/SignUpLimitThanks" exact component={SignUpLimitThanks} />
      <Route path="/RequestConsult" exact component={RequestConsult} />
      <Route path="/StreamLocatorCaseStudy" exact component={StreamLocatorCaseStudy} />
      <Route path="/SMSLiveCaseStudy" exact component={SMSLiveCaseStudy} />
      <Route path="/FreeTrial" exact component={FreeTrial} />
      <Route path="/FreeVersion" exact component={FreeVersion} />
      <Route path="/FloSQLSnowflake" exact component={FloSQLSnowflake} />
      <Route path="/FloSQLRedshift" exact component={FloSQLRedshift} />
      <Route path="/FloSQLBigQuery" exact component={FloSQLBigQuery} />
      <Route path="/FormSubmitted" exact component={FormSubmitted} />
      <Route path="/FormSubmittedFree" exact component={FormSubmittedFree} />
      <Route path="/SelectDestination" exact component={SelectDestination} />
      {/* add routes without layouts */}
      <Route path="/" exact component={HomePage} />
      {/* add redirect for first page */}
      <Redirect from="*" to="/" />
    </Switch>
  </div>
);

}
